import { z } from "zod/v4";
export const noteSchema = z
    .union([
    z.literal("1"),
    z.literal("2"),
    z.literal("3"),
    z.literal("4"),
    z.literal("5"),
])
    .transform((val) => parseInt(val, 10));
export const improvementDomains = [
    "phone",
    "office",
    "practitioner",
    "nurse",
    "care",
    "prices",
    "freeText",
];
export const officeImprovementDomains = [
    "cleanliness",
    "equipment",
    "easyToFind",
    "freeText",
];
export const practitionerImprovementDomains = [
    "welcoming",
    "communication",
    "waitingTime",
    "expertise",
    "explanations",
    "listeningSkills",
    "freeText",
];
export const treatmentsImprovementDomains = [
    "pain",
    "qualityEndResult",
    "sessionDifficulty",
    "sessionExplanations",
    "freeText",
];
export const answerSchema = z.object({
    globalFreeAnswer: z.string().max(1000),
    otherComplaint: z.string().max(1000),
    note: z
        .union([
        z.literal(1),
        z.literal(2),
        z.literal(3),
        z.literal(4),
        z.literal(5),
    ])
        .nullable(),
    domainsChecked: z.array(z.enum(improvementDomains)),
    domainsAnswered: z.object({
        phone: z.object({
            freeText: z.string().max(1000),
        }),
        office: z.object({
            freeText: z.string().max(1000),
            domains: z.array(z.enum(officeImprovementDomains)),
        }),
        practitioner: z.object({
            freeText: z.string().max(1000),
            domains: z.array(z.enum(practitionerImprovementDomains)),
        }),
        nurse: z.object({
            freeText: z.string().max(1000),
        }),
        treatments: z.object({
            freeText: z.string().max(1000),
            domains: z.array(z.enum(treatmentsImprovementDomains)),
        }),
        prices: z.object({
            freeText: z.string().max(1000),
        }),
    }),
    version: z.literal(1),
});
//# sourceMappingURL=QuestionsSchemas.js.map